import { PaymentType, isBack } from 'consts/PaymentConst';
import { GetBulkOrderResData } from 'requests/RequestPayment';

type RedirectProps = {
	payMethod: PaymentType;
	is_via_portal: boolean;
	state?: string;
	redirect_uri: string;
	order: GetBulkOrderResData;
};
export const bulkRedirect = (props: RedirectProps) => {
	const { payMethod, is_via_portal, state, redirect_uri, order } = props;

	const isViaPortalParam = `&is_via_portal=${Number(is_via_portal)}`;
	const stateParam = state ? `&state=${encodeURIComponent(state)}` : '';
	if (isBack(payMethod)) {
		window.location.href = `${redirect_uri}?payment_type=${payMethod.key}${stateParam}${isViaPortalParam}`;
		return;
	}
	const periodicParam = order.periodic_payment_id ? `&periodic_payment_id=${order.periodic_payment_id}` : '';
	window.location.href = `${redirect_uri}?gid_order_no=${order.gid_order_no}&payment_type=${payMethod.key}${stateParam}${periodicParam}${isViaPortalParam}`;
};
